import styled from 'styled-components';

export const StyledOrderedShowcaseItem = styled.div`
  height: 100%;
  ${({ $clickable }) => $clickable && 'cursor: pointer;'};
`;

export const ShowcaseItem = styled.div`
  height: 100%;
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;

  canvas {
    ${({ $itemSizeLimit }) => ($itemSizeLimit) && `
      max-width: ${$itemSizeLimit};
      max-height: ${$itemSizeLimit};
    `}
  }
`;

export const Image = styled.img`
  display: block;
  height: auto;
  object-fit: contain;

  ${({ $itemSizeLimit }) => ($itemSizeLimit) && `
    max-width: ${$itemSizeLimit};
    max-height: ${$itemSizeLimit};
  `}
`;
